import React from 'react'
import { Header, Container, Button, Icon } from 'semantic-ui-react'
import { Modes } from '../utils/dummyState'

const ScreenSizes = {
    PHONE_PORTRAIT: 'phone_portrait',
    PHONE_LANDSCAPE: 'phone_landscape',
    TABLET_PORTRAIT: 'tablet_portrait',
    TABLET_LANDSCAPE: 'tablet_landscape',
    DESKTOP: 'desktop'
} 

const TabSettings = {
    [ScreenSizes.PHONE_PORTRAIT]: 'width=320, height=480, resizable=no,location=yes,toolbar=yes',
    [ScreenSizes.PHONE_LANDSCAPE]: 'width=480, height=320, resizable=no,location=yes,toolbar=yes',
    [ScreenSizes.TABLET_PORTRAIT]: 'width=672, height=1024, resizable=no,location=yes,toolbar=yes',
    [ScreenSizes.TABLET_LANDSCAPE]: 'width=1024, height=672, resizable=no,location=yes,toolbar=yes',
}

const PageLink = ({ mode, size, children }) => (
    <tr>
        <td>{children}</td>
        <td>
            <Button primary onClick={() => window.open(`?s=${mode}`, '', TabSettings[ScreenSizes.PHONE_PORTRAIT])}><Icon name='tablet alternate' /></Button>
            <Button primary onClick={() => window.open(`?s=${mode}`, '', TabSettings[ScreenSizes.PHONE_LANDSCAPE])}><Icon name='tablet alternate' rotated='counterclockwise' /></Button>
            <Button primary onClick={() => window.open(`?s=${mode}`, '', TabSettings[ScreenSizes.DESKTOP])}><Icon name='computer' /></Button>
        </td>
    </tr>
)

export default () => (
    <Container>
        <Header>Stati</Header>
        <table>
            <tbody>
            <PageLink mode={Modes.WAITING_MATCH}>Partita non iniziata</PageLink>
            <PageLink mode={Modes.STARTED_MATCH}>Partita iniziata</PageLink>
            <PageLink mode={Modes.QUESTION_BET}>Scommessa</PageLink>
            <PageLink mode={Modes.QUESTION_TO_ASK}>Scommessa fatta</PageLink>
            <PageLink mode={Modes.QUESTION_TO_ANSWER}>Domanda da rispondere</PageLink>
            <PageLink mode={Modes.QUESTION_ANSWERED}>Risposta data</PageLink>
            <PageLink mode={Modes.QUESTION_RESULT_RIGHT}>Risposta data: giusta</PageLink>
            <PageLink mode={Modes.QUESTION_RESULT_WRONG}>Risposta data: sbagliata</PageLink>
            <PageLink mode={Modes.QUESTION_RESULT_BLACK}>Risposta data: BLACK ANSWER</PageLink>
            <PageLink mode={Modes.QUESTION_NO_POINTS}>Domanda senza punti</PageLink>
            <PageLink mode={Modes.ENDED_MATCH}>Partita finita</PageLink>
            </tbody>
        </table>
    </Container>
)


// WEBPACK FOOTER //
// ./src/components/DevPage.js